"use strict";

var Prompt = require("app/shared/components/Prompt/prompt");
var BoldText = require("app/shared/components/BoldText/bold-text");

var config = require("app/util/config/config");
var TRIAL_DAYS = config.app.trialDays;

const FREE_PLAN_MAX_USERS = 3;

var PromptActivateTrial = React.createClass({
  propTypes: {
    redirectUrl: React.PropTypes.string.isRequired,
    planValuePerUser: React.PropTypes.number.isRequired,
    isOpen: React.PropTypes.bool
  },
  getDefaultProps: function() {
    return {
      isOpen: false
    };
  },
  render: function() {
    var props = {
      title: "Atenção!",
      type: "confirm",
      hideWarningIcon: false,
      buttonText: "Experimentar Plano Pro",
      buttonClasses: "btn btn-success",
      autoClose: false,
      isOpen: this.props.isOpen,
      onClose: this.props.onClose,
      onConfirm: function() {
        window.location.href = this.props.redirectUrl;
        this.props.onClose();
      }.bind(this)
    };
    var firstParagraph = "Você está prestes a ativar a **experimentação " +
      "gratuita por 7 dias do Plano Pro** " +
      "que te dá direito a todas as funcionalidades do Agendor. " +
      "Caso você se interesse por esse plano e queira continuar " +
      "após os 7 dias grátis, você poderá assiná-lo no **valor de " +
      "R$ 53 por mês** (por usuário).";
    var secondParagraph = "Obs.: A qualquer momento, **você poderá reverter para o " +
      "Plano Gratuito** (seu plano atual, que suporta até " + FREE_PLAN_MAX_USERS + " usuários e " +
      "recursos limitados) a partir de 'Menu > Planos e Preços', " +
      "clicando no botão 'Reduzir para o Agendor Gratuito'.";
    return (
      <Prompt {...props}>
        <div className="prompt-text maxw-550">
          <p>
            <BoldText text={firstParagraph} />
          </p>
          <p>
            <BoldText text={secondParagraph} />
          </p>
        </div>
      </Prompt>
    );
  }
});

module.exports = PromptActivateTrial;



// WEBPACK FOOTER //
// ./app/shared/components/Prompt/prompt-activate-trial.jsx